import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { CiEdit } from "react-icons/ci";
import { MdDeleteOutline } from "react-icons/md";
import { useSelector } from "react-redux";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { checkAccessFn } from "../../../../utils/checkAccess";
import Highlighter from "react-highlight-words";

export default function ListProfessionalLevel({
  professionList = [],
  deleteData,
  loading,
  titles = [
    "S.No",
    "PROFESSION LEVELS",
    "NITAKAT",
    "ADMIN FEE",
    "SOUNDLINE FEE",
    "Action",
  ],
  setAddEditPopup,
  addData,
  listLoading,
}) {
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(professionList || []);
  const [noData, setNoData] = useState(false);
  const dashboardData = useSelector((state) => state.dashboardData);
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const [searchWords, setSearchWords] = useState([]);

  return (
    <div className="pt-2">
      <div className="flex flex-wrap items-center gap-2 mb-1">
        {checkAccess("PROFESSION LEVELS", "profession-levels-create") && (
          <button
            className="p-2 bg-red text-white rounded-md"
            onClick={addData}
          >
            ADD NEW PROFESSION LEVEL +
          </button>
        )}
        <Search
          searchKey={["name", "nitakat", "admin_fee", "soundline_fee"]}
          setSearchWords={setSearchWords}
        />
        <CountPerPage />
      </div>
      <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block">{`Slide / scroll to right >`}</p>
      <div
        className={`grid grid-cols-table-profession-lvl auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((title, index) => (
          <p key={index} className="font-semibold uppercase">
            {title}
          </p>
        ))}
        {listLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-6">
            {loading && <CgSpinner className="animate-spin" />}
          </div>
        )}
        {!listLoading && currentList.length <= 0 && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-6">
            <p>Data not found</p>
          </div>
        )}
        {currentList.map((list, index) => (
          <React.Fragment key={index}>
            <PaginationIndex index={index} />

            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list?.name || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list?.nitakat || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list?.admin_fee || "-"}
              />
            </p>
            <p>
              <Highlighter
                searchWords={searchWords}
                autoEscape={true}
                textToHighlight={list?.soundline_fee || "-"}
              />
            </p>

            <div className="flex gap-3 min-w-fit ">
              {checkAccess("PROFESSION LEVELS", "profession-levels-edit") ? (
                <button
                  className={
                    listLoading || currentList?.length <= 0
                      ? "p-1 px-2 rounded-md ring-1 ring-slate-600 opacity-50"
                      : `p-1 px-2 rounded-md ring-1 ring-slate-600 `
                  }
                  disabled={listLoading || currentList?.length <= 0}
                  onClick={() =>
                    setAddEditPopup((p) => ({
                      ...p,
                      id: list.id,
                      open: true,
                      mode: "edit",
                      data: {
                        name: list?.name,
                        nitakat: list?.nitakat,
                        admin_fee: list?.admin_fee,
                        soundline_fee: list?.soundline_fee,
                      },
                    }))
                  }
                >
                  <CiEdit size={"1.4rem"} />
                </button>
              ) : (
                <button
                  className={`p-1 px-2 rounded-md ring-1 ring-slate-300 cursor-not-allowed `}
                  disabled
                >
                  --
                </button>
              )}

              {checkAccess("PROFESSION LEVELS", "profession-levels-delete") ? (
                <button
                  className={
                    listLoading || currentList?.length <= 0
                      ? "p-1 px-2 rounded-md ring-1 ring-red bg-red text-white opacity-50"
                      : `p-1 px-2 rounded-md ring-1 ring-red bg-red text-white `
                  }
                  disabled={listLoading || currentList?.length <= 0}
                  onClick={() =>
                    deleteData((oldState) => ({ open: true, id: list.id }))
                  }
                >
                  <MdDeleteOutline size={"1.4rem"} />
                </button>
              ) : (
                <button
                  className={`p-1 px-2 rounded-md ring-1 ring-slate-300 cursor-not-allowed`}
                  disabled
                >
                  --
                </button>
              )}
            </div>
            <hr
              className={`border-[1.5px] border-slate-100  w-full col-span-6 `}
            />
          </React.Fragment>
        ))}
      </div>
      <Pagination />
    </div>
  );
}
